import { createSlice } from "@reduxjs/toolkit";
import {
  FetchingListOfSpecies,
  FetchingSharingStatusData,
  FetchingTypeOfData,
  ListOfPartnerOrganisations,
  SelectedSite,
  StoragesData,
} from "./shareSiteTypes";

import {
  deleteStorageSharing,
  fetchingSharingStatus,
  fetchListOfPartnerOrganisations,
  fetchStoragesOfEachLocationLocationView,
  listSpecies,
  storageSharing,
  typeOfBin,
} from "../../actions/shareSite/shareSiteAsync";
import { logOut } from "../layout";

export interface ShareSiteState {
  listOfPartnerOrganisations: ListOfPartnerOrganisations | undefined;
  loadingFetchPartnerOrganisations: boolean;
  errorFetchPartnerOrganisations: string;

  selectedSite: SelectedSite;
  selectedPatner: string;

  storages: StoragesData;
  storagesLoading: boolean;
  storagesError: string;

  selectedStoragesIds: string[];

  sharingStatus: FetchingSharingStatusData;
  sharingStatusLoading: boolean;
  sharingstatusError: string;

  listOfSpeciesFilter: FetchingListOfSpecies;
  listOfSpeciesLoading: boolean;
  listOfSpeciesError: string;
  selectedSpecie: number;

  listOfTypesFilter: FetchingTypeOfData;
  listTypeOfLoading: boolean;
  lisTypetOfError: string;
  selectedType: string;

  toDelete: string[];
  toKeep: string[];

  storageSharing: {
    loading: boolean;
    error: string;
    success: boolean;
  };

  storageSharedDelete: {
    loading: boolean;
    error: string;
    success: boolean;
  };
  successShareDeleteBins: boolean;
  selectedSort: string;
}

export const initialState: ShareSiteState = {
  listOfPartnerOrganisations: undefined,
  loadingFetchPartnerOrganisations: false,
  errorFetchPartnerOrganisations: "",

  selectedSite: {
    name: "",
    id: "",
  },

  selectedPatner: "",

  storages: {
    total: 0,
    limit: 0,
    skip: 0,
    data: [],
  },
  storagesLoading: false,
  storagesError: "",

  selectedStoragesIds: [],

  sharingStatus: {
    total: 0,
    limit: 0,
    skip: 0,
    data: [],
  },
  sharingStatusLoading: false,
  sharingstatusError: "",

  listOfSpeciesFilter: {
    total: 0,
    limit: 0,
    skip: 0,
    data: [],
  },
  listOfSpeciesLoading: false,
  listOfSpeciesError: "",
  selectedSpecie: 0,

  listOfTypesFilter: {
    total: 0,
    limit: 0,
    skip: 0,
    data: [],
  },
  listTypeOfLoading: false,
  lisTypetOfError: "",
  selectedType: "",

  toDelete: [],
  toKeep: [],

  storageSharing: {
    loading: false,
    error: "",
    success: false,
  },

  storageSharedDelete: {
    loading: false,
    error: "",
    success: false,
  },

  successShareDeleteBins: false,
  selectedSort: "by-used-capacity",
};

export const ShareSiteSlice = createSlice({
  name: "ShareSiteReducer",
  initialState,
  reducers: {
    setSelectedSort(state, action) {
      return {
        ...state,
        selectedSort: action.payload,
      };
    },
    setStorages(state, action) {
      return {
        ...state,
        storages: action.payload,
      };
    },

    setSuccessShareDeleteBins(state, action) {
      return {
        ...state,
        successShareDeleteBins: action.payload,
      };
    },
    setToDelete(state, action) {
      return {
        ...state,
        toDelete: action.payload,
      };
    },

    setToKeep(state, action) {
      return {
        ...state,
        toKeep: action.payload,
      };
    },

    setSelectTypeOfFilter(state, action) {
      return {
        ...state,
        selectedType: action.payload,
      };
    },

    setSelectSpecieFilter(state, action) {
      return {
        ...state,
        selectedSpecie: action.payload,
      };
    },

    setSelectedStoragesIds(state, action) {
      return {
        ...state,
        selectedStoragesIds: action.payload,
      };
    },
    setSelectedPartner(state, action) {
      return {
        ...state,
        selectedPatner: action.payload,
      };
    },
    setSelectedSiteToShare(state, action) {
      return {
        ...state,
        selectedSite: action.payload,
      };
    },
    setListOfPartnerOrganisations(state, action) {
      return {
        ...state,
        listOfPartnerOrganisations: action.payload,
      };
    },

    resetStateShareSite() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchListOfPartnerOrganisations.pending, (state) => {
        state.loadingFetchPartnerOrganisations = true;
        state.errorFetchPartnerOrganisations = "";
      })
      .addCase(fetchListOfPartnerOrganisations.fulfilled, (state, action) => {
        state.loadingFetchPartnerOrganisations = false;
        state.listOfPartnerOrganisations = action.payload;
      })
      .addCase(fetchListOfPartnerOrganisations.rejected, (state, action) => {
        state.loadingFetchPartnerOrganisations = false;
        state.errorFetchPartnerOrganisations = action.payload as string;
      });

    builder
      .addCase(fetchStoragesOfEachLocationLocationView.pending, (state) => {
        state.storagesLoading = true;
        state.storagesError = "";
      })
      .addCase(
        fetchStoragesOfEachLocationLocationView.fulfilled,
        (state, action) => {
          state.storagesLoading = false;
          state.storages = action.payload;
        }
      )
      .addCase(
        fetchStoragesOfEachLocationLocationView.rejected,
        (state, action) => {
          state.storagesLoading = false;
          state.storagesError = action.payload as string;
        }
      );

    builder
      .addCase(fetchingSharingStatus.pending, (state) => {
        state.sharingStatusLoading = true;
        state.sharingstatusError = "";
      })
      .addCase(fetchingSharingStatus.fulfilled, (state, action) => {
        state.sharingStatusLoading = false;
        state.sharingStatus = action.payload;
      })
      .addCase(fetchingSharingStatus.rejected, (state, action) => {
        state.sharingStatusLoading = false;
        state.sharingstatusError = action.payload as string;
      });

    builder
      .addCase(listSpecies.pending, (state) => {
        state.listOfSpeciesLoading = true;
        state.listOfSpeciesError = "";
      })
      .addCase(listSpecies.fulfilled, (state, action) => {
        state.listOfSpeciesLoading = false;
        state.listOfSpeciesFilter = action.payload;
      })
      .addCase(listSpecies.rejected, (state, action) => {
        state.listOfSpeciesLoading = false;
        state.listOfSpeciesError = action.payload as string;
      });

    builder
      .addCase(typeOfBin.pending, (state) => {
        state.listTypeOfLoading = true;
        state.lisTypetOfError = "";
      })
      .addCase(typeOfBin.fulfilled, (state, action) => {
        state.listTypeOfLoading = false;
        state.listOfTypesFilter = action.payload;
      })
      .addCase(typeOfBin.rejected, (state, action) => {
        state.listTypeOfLoading = false;
        state.lisTypetOfError = action.payload as string;
      });

    builder
      .addCase(storageSharing.pending, (state) => {
        state.storageSharing.loading = true;
        state.storageSharing.error = "";
      })
      .addCase(storageSharing.fulfilled, (state) => {
        state.storageSharing.loading = false;
        state.storageSharing.success = true;
      })
      .addCase(storageSharing.rejected, (state, action) => {
        state.storageSharing.loading = false;
        state.storageSharing.error = action.payload as string;
      });

    builder
      .addCase(deleteStorageSharing.pending, (state) => {
        state.storageSharedDelete.loading = true;
        state.storageSharedDelete.error = "";
      })
      .addCase(deleteStorageSharing.fulfilled, (state) => {
        state.storageSharedDelete.loading = false;
        state.storageSharedDelete.success = true;
      })
      .addCase(deleteStorageSharing.rejected, (state, action) => {
        state.storageSharedDelete.loading = false;
        state.storageSharedDelete.error = action.payload as string;
      });

    builder.addCase(logOut, () => {
      return initialState;
    });
  },
});

export const {
  setSelectedSort,
  setStorages,
  setSuccessShareDeleteBins,
  setToDelete,
  setToKeep,
  setSelectTypeOfFilter,
  setSelectSpecieFilter,
  setSelectedStoragesIds,
  setSelectedPartner,
  setListOfPartnerOrganisations,
  resetStateShareSite,
  setSelectedSiteToShare,
} = ShareSiteSlice.actions;
export const ShareSite = ShareSiteSlice.reducer;
